import { BusStudentCheckin } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    busStudentTrackings: [],
    totalCount: 0,
    loading: false,
    query: {}
  },
  actions: {
    async fetch({ commit }, params) {
      const busStudentTrackings = await BusStudentCheckin.fetch(params)
      commit('changeState', { busStudentTrackings })
    },
    async count({ commit }, params) {
      const totalCount = await BusStudentCheckin.count(params)
      commit('changeState', { totalCount })
    }
  },
  mutations: {
    setState(state, { attribute, data }) {
      state[attribute] = data
    }
  },
  getters: {}
}
